import { Controller } from '@hotwired/stimulus'
import Choices from 'choices.js'

export default class extends Controller {
  static targets = ["supplierEmailInput"]

  initialize() {
    new Choices(document.querySelector("#email_po_ids"))
  }

  onSupplierChange(e) {
    this.supplierEmailInputTarget.value = e.target.value
  }

}